import * as yup from 'yup';

export const CreateSiteAccessValidationSchema = yup.object({
	user_id: yup.number().required('User ID is required'),
	type: yup
		.string()
		.oneOf(['admin', 'member'], 'Type must be either admin or member')
		.required('Type is required'),
	roles: yup
		.array()
		.of(yup.string().oneOf(['data_collector', 'annotator']).required())
		.default([])
		.when('type', {
			is: 'member',
			then: (schema) =>
				schema.min(1, 'At least one role is required for members'),
			otherwise: (schema) => schema.max(0, 'No roles required'),
		}),
	can_add_patient: yup.boolean().required('Can Add Patient is required'),
	initials: yup
		.string()
		.trim()
		.matches(/^\S+$/, 'No spaces are allowed in initials')
		.max(6, 'Initials must be 6 or fewer characters')
		.when('can_add_patient', {
			is: true,
			then: (schema) =>
				schema.required(
					'Initials are required when patient creation is allowed',
				),
			otherwise: (schema) => schema.notRequired(),
		}),
});

export const EditSiteAccessRoleValidationScheme = yup.object().shape({
	type: yup
		.string()
		.oneOf(['admin', 'member'], 'Type must be either admin or member')
		.required('Type is required'),
	roles: yup
		.array()
		.of(yup.string().oneOf(['data_collector', 'annotator']).required())
		.default([])
		.when('type', {
			is: 'member',
			then: (schema) =>
				schema.min(1, 'At least one role is required for members'),
			otherwise: (schema) => schema.max(0, 'No roles required'),
		}),
});
